"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFacebook = void 0;
var React = __importStar(require("react"));
var IconFacebook = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20.0064,3 L3.9936,3 C3.4446,3 3,3.4446 3,3.9936 L3,20.0064 C3,20.5554 3.4446,21 3.9936,21 L12.6156,21 L12.6156,14.0394 L10.2774,14.0394 L10.2774,11.3142 L12.6156,11.3142 L12.6156,9.309 C12.6156,6.9852 14.034,5.7198 16.1076,5.7198 C17.1012,5.7198 17.9562,5.7936 18.2046,5.8242 L18.2046,8.256 L16.7754,8.256 C15.6468,8.256 15.4272,8.7924 15.4272,9.579 L15.4272,11.3142 L18.1254,11.3142 L17.7744,14.0394 L15.4272,14.0394 L15.4272,21 L20.0064,21 C20.5554,21 21,20.5554 21,20.0064 L21,3.9936 C21,3.4446 20.5554,3 20.0064,3" }))); };
exports.IconFacebook = IconFacebook;
exports.IconFacebook.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFacebook;
